<template>
  <div>
    <!-- <div class="w100 pt20">{{ layout }}</div> -->
    <grid-layout style="min-height: 370px;" :layout.sync="layout" :col-num="3" :row-height="350" :is-draggable="canDrag" :is-resizable="canDrag" :margin="[10, 10]" v-loading="loading || stepUpload">
      <grid-item v-for="(item, index) in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :max-h="2" :i="item.i" :key="item.i" @resized="resizedEvent">
        <div class="po-r w100 h100 bor card-shadow card-view">
          <component class="w100 h100" :ref="item.i" :is="item.compId" :w="item.w" :h="item.h" :can-drag="canDrag"></component>
          <i v-if="canDrag && cardList.length" class="po-a option font-18 grey cu-p el-icon-s-tools" @click.stop="showCardList(item.compId, index)"></i>
          <i v-if="canDrag" class="po-a move font-18 grey cu-p el-icon-close" @click.stop="moveComp(index)"></i>
        </div>
      </grid-item>
    </grid-layout>

    <el-dialog title="选择卡片" :visible.sync="show" width="300px">
      <el-select class="w100" v-model="compId" placeholder="请选择卡片">
        <el-option v-for="(item, index) in cardList" :key="index" :label="item.compName" :value="item.compId"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <el-button type="primary" :disabled="!compId" @click="changeCard">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VueGridLayout from "vue-grid-layout";
import CardApp from "@/components/homeCard/cardApp/CardApp";
import CardCalendar from "@/components/homeCard/cardCalendar/CardCalendar";
import CardNotice from "@/components/homeCard/cardNotice/CardNotice";
import CardSchedule from "@/components/homeCard/cardSchedule/CardSchedule";
import CardServe from "@/components/homeCard/cardServe/CardServe";
import CardTool from "@/components/homeCard/cardTool/CardTool";

export default {
  name: "LayoutView",
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    CardApp,
    CardCalendar,
    CardNotice,
    CardSchedule,
    CardServe,
    CardTool
  },
  props: ["can-drag", "layout-id", "step-upload"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      layout: [],
      show: false,
      cardList: [],
      compId: "",
      editIndex: 0
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.fetchCardList();
    this.fetchLayout();
  },
  destroyed() {},
  methods: {
    // 获取该角色可用卡片
    fetchCardList() {
      this.$http
        .get(this.$base.menhuUrl + "/tabCardInfo/findCardsByRole")
        .then(({ data }) => {
          if (data.resCode == 0) {
            let arr = [];
            data.resData.forEach( e => {
              arr.push({ compId: e.comId, compName: e.comName, cardId: e.cardId })
            })
            this.cardList = arr;
          }
        })
        .catch(() => {});
    },
    // 根据布局id获取布局配置
    fetchLayout() {
      this.loading = true;
      this.$http
        .get(this.$base.menhuUrl + "/tabCardPosition/findPositionsByLayoutId", {params: { layoutId: this.layoutId }})
        .then(({ data }) => {
          if (data.resCode == 0) {
            // 转换数组的 key
            data.resData.forEach( (e, index) => {
              data.resData[index].compId = e.comId;
              data.resData[index].i = this.roll(10);
              delete data.resData[index].comId
            })
            this.layout = data.resData;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
      // setTimeout(() => {
      //   this.layout = [
      //     { "x":1, "y":0, "w":2, "h":1, "i":"i0", "compId":"CardApp", "moved":false },
      //     { "x":0, "y":0, "w":1, "h":1, "i":"i1", "compId":"CardSchedule", "moved":false },
      //     { "x":0, "y":1, "w":1, "h":2, "i":"i2", "compId":"CardNotice", "moved":false },
      //     { "x":1, "y":1, "w":2, "h":1, "i":"i3", "compId":"CardServe", "moved":false },
      //     { "x":1, "y":2, "w":1, "h":1, "i":"i4", "compId":"CardCalendar", "moved":false },
      //     { "x":2, "y":2, "w":1, "h":1, "i":"i5", "compId":"CardTool", "moved":false }
      //   ];
      //   this.loading = false;
      // }, 500);
    },
    // 显示卡片列表
    showCardList(id, index) {
      this.compId = id ? id : "";
      this.editIndex = index;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    // 点击确认
    changeCard() {
      let cardId = "";
      // 判断如果是新增，cardId:选中的卡片cardId( 新增的时候，cardId:cardId )
      this.cardList.map( val => {
        // 选中的组件名 与 下来列表中的数据比配，获取其id并保存其id
        if ( this.compId === val.compId ) {
          cardId = val.cardId
        }
      })

      // 新增
      if (this.editIndex === -1) {
        // 新增只有cardId
        this.addGridItem(cardId);
      } else {
        // 如果是编辑会有index
        this.editGridItem(cardId);
      }
      this.show = false;
    },
    // 修改卡片
    editGridItem(cardId) {
      this.layout[this.editIndex].compId = this.compId;
      this.layout[this.editIndex].cardId = cardId;
    },
    // 新增卡片
    addGridItem(cardId) {
      this.layout.push({
        x: 0,
        y: 0,
        w: 1,
        h: 1,
        i: this.roll(10),
        cardId: cardId,
        compId: this.compId,
        positionId: ""
      });

      // let x = 0,
      //   y = 0,
      //   w = 0,
      //   h = 1,
      //   num = this.roll(10);
      // let maxY = -1,
      //   lastData = [];
      // // 获取到最后一行的数据
      // for (const item of this.layout) {
      //   if (item.y > maxY) {
      //     maxY = item.y;
      //     y = item.y;
      //     lastData = [];
      //   }
      //   lastData.push(item);
      // }
      // // 获取最后一个卡片的位置
      // let maxX = -1;
      // for (const item of lastData) {
      //   if (item.x > maxX) {
      //     maxX = item.x;
      //     x = item.x;
      //     w = item.w;
      //   }
      // }
      // // 如果最后一张卡片在最右边，就在下一行添加
      // if (x + w == 3) {
      //   y = y + 1;
      //   x = 0;
      // } else {
      //   x = x + w;
      // }
      // this.layout.push({
      //   x: x,
      //   y: y,
      //   w: 1,
      //   h: 1,
      //   i: num,
      //   compId: this.cardId
      // });
    },
    // 移除卡片
    moveComp(index) {
      this.layout.splice(index, 1);
    },
    getLayout() {
      return this.layout;
    },
    // 随机数字符串（长度）
    roll(maxLength) {
      let num = "";
      for (let i = 0; i < maxLength; i++) {
        num += Math.floor(Math.random() * 10);
      }
      return "&_i" + num;
    },
    // 调整大小后事件
    resizedEvent(i) {
      // 只有编辑模式才能改变大小，其他情况下不做事件发送给卡片（比如刚进入页面或者切换模板所有的卡片都会触发该事件）
      if (!this.canDrag) {
        return;
      }
      if (this.$refs[i][0].resizedEvent) {
        this.$refs[i][0].resizedEvent();
      }
    }
  },
  watch: {
    layoutId(value) {
      if (value) {
        this.fetchLayout();
      }
    }
  },
  filters: {}
};
</script>

<style scoped>
.card-view {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
}

.card-view .option {
  right: 30px;
  top: 8px;
}

.card-view .move {
  right: 8px;
  top: 8px;
}
</style>
